import React, { useEffect, useState } from "react";
import { Collapse, Skeleton, Alert } from "antd";
import { CaretRightOutlined } from "@ant-design/icons";
import { fetchApi } from "../services/api";

export default function HelpPage() {
  const [loading, setLoading] = useState(true);
  const [helpContent, setHelpContent] = useState([]);
  const [faqs, setFaqs] = useState([]);
  const [alertInfo, setAlertInfo] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/version`)
      .then((res) => res.json())
      .then((result) => setAlertInfo(result?.data?.card_data))
      .catch((error) => console.error("Failed to fetch version info:", error));
  }, []);

  useEffect(() => {
    async function loadHelp() {
      try {
        const res = await fetchApi("website-faqs");

        const response = res?.data || {};

        setHelpContent(response.help_content || []);
        setFaqs(response.faqs || []);
      } catch (error) {
        console.error("Help API Error:", error);
      } finally {
        setLoading(false);
      }
    }

    loadHelp();
  }, []);

  const fixHtml = (html = "") =>
    html
      .replaceAll("className=", "class=")
      .replace(/<p><p/g, "<p")
      .replace(/<\/p><\/p>/g, "</p>");

  const helpPage = helpContent.find(
    (item) => item.page_title?.toUpperCase() === "HELP"
  );

  const emailPage = helpContent.find(
    (item) => item.page_title?.toUpperCase() === "EMAIL"
  );

  const faqItems = [...faqs]
    .sort(
      (a, b) => Number(a.display_order) - Number(b.display_order)
    )
    .map((faq) => ({
      key: faq.id,
      label: (
        <div
          dangerouslySetInnerHTML={{
            __html: fixHtml(faq.title),
          }}
        />
      ),
      children: (
        <div
          className="text-sm text-slate-600 leading-relaxed"
          dangerouslySetInnerHTML={{
            __html: fixHtml(faq.answer),
          }}
        />
      ),
    }));

  if (loading) {
    return (
      <div className="max-w-6xl mx-auto px-6 lg:px-8 py-12">
        <Skeleton active paragraph={{ rows: 12 }} />
      </div>
    );
  }

  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-8 py-12 space-y-6">
      {alertInfo?.message && alertInfo?.type != null && (
        <Alert
          description={<div dangerouslySetInnerHTML={{ __html: alertInfo.message }} />}
          type={alertInfo.type === 1 ? "error" : "warning"}
          className="mb-4"
        />
      )}

      {/* Help Content */}
      <div
        dangerouslySetInnerHTML={{
          __html: fixHtml(helpPage?.page_content || ""),
        }}
      />

      {/* FAQs */}
      {!(alertInfo?.message && alertInfo.type === 1) && (
        <div className="bg-white rounded-lg shadow-sm p-6">
          <h1 className="text-lg mb-3 text-slate-700 font-semibold">
            FAQs
          </h1>

          <Collapse
            accordion
            bordered={false}
            expandIcon={({ isActive }) => (
              <CaretRightOutlined rotate={isActive ? 90 : 0} />
            )}
            items={faqItems}
          />

          {emailPage?.page_content && (
            <div
              className="mt-6 text-sm text-slate-600"
              dangerouslySetInnerHTML={{
                __html: fixHtml(emailPage.page_content),
              }}
            />
          )}
        </div>
      )}
    </div>
  );
}